export default "__VITE_PUBLIC_ASSET__2667fc98__"